export const defaultRelatorio =  `
<table style="width: 100%; border-spacing: 0;">
   <thead>      
      <tr>
         <th style="border-width: 0px">
            <div>
               <div style="display: flex; flex-direction: row; ">
                  <div style="display: flex; flex-direction: column;">
                     <img src="data:image/jpeg;base64, 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" style="max-height: 120px; max-width: 250px; margin: auto" aling="left" />
                  </div>
                  <div style="flex: 1; justify-content: center; align-itens: center; margin: auto;">
                     <h3 class="title">@{this.empresa.empnome}</h3>
                     <h3 class="subtitle">CADASTRO PARA ADMISSÃO DO FUNCIONÁRIO</h3>
                  </div>
               </div>
            </div>
            <div style="border: 1px black solid; border-top-width: 1px; border-right-width: 0px; border-top-left-radius: 12px; border-top-right-radius: 12px;">
               <div class="rowElement">
                  <div class="cellElement" style="border-top-width: 0">
                     <h5>Nome completo</h5>
                     <h4 style="align-self: flex-end;">@{this.colaborador?.colnome || ''}</h4>
                  </div>
                  <div class="cellElement" style="border-top-width: 0px">
                     <h5>CPF</h5>
                     <h4 style="align-self: flex-end;">@{this.colaborador?.colcpf || ''}</h4>
                  </div>
                  <div class="cellElement" style="border-top-width: 0; border-right-width: 0; ">
                     <div class="rowElement">
                        <div class="cellElement" style="border-top-width: 0px; padding-left: 0">
                           <h5>Sexo</h5>
                           <h4>@{['Masculino', 'Feminino', 'Prefiro não informar', 'Outros'][this.colaborador?.colsexo]}</h4>
                        </div>
                        <div class="cellElement" style="border-top-width: 0; border-top-right-radius: 12px">
                           <h5>Data de Admissão</h5>
                           <h4>@{this.colaborador?.coladmissao ? moment(this.colaborador?.coladmissao).format("DD/MM/YYYY") : ''}</h4>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>RG</h5>
                     <h4>@{this.colaborador?.colrg || ''}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Orgão de Expedição</h5>
                     <h4>@{this.colaborador?.colrgorgaoexpedicao || ''}</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Data de Expedição</h5>
                     <h4>@{this.colaborador?.colrgdataexpedicao ? moment(this.colaborador?.colrgdataexpedicao).format("DD/MM/YYYY") : ' '}</h4>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>Função</h5>
                     <h4>@{this.cargo?.cardescricao || ''}&nbsp</h4>
                  </div>
                  <div class="cellElement" style="border-right-width: 0; ">
                     <div class="rowElement">
                        <div class="cellElement" style="border-top-width: 0px; padding-left: 0">
                           <h5>Setor</h5>
                           <h4>@{this.grupo?.grudescricao || ''}</h4>
                        </div>
                        <div class="cellElement" style="border-top-width: 0">
                           <h5>Jornada</h5>
                           <h4>@{this.jornadatrabalho?.jorntrabdescricao || ''}</h4>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>Endereço</h5>
                     <h4>@{this.colaborador?.collogradouro || ''}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Nº</h5>
                     <h4>@{this.colaborador?.collogradouronumero || ''}</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Bairro</h5>
                     <h4>@{this.colaborador?.colbairro || ' '}&nbsp</h4>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>Município</h5>
                     <h4>@{this.municipio?.munnome || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>UF</h5>
                     <h4>@{this.municipio?.munuf || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>CEP</h5>
                     <h4>@{this.colaborador?.colcep || ' '}&nbsp</h4>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>Telefone</h5>
                     <h4>@{this.colaborador?.coltelefone || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>E-mail</h5>
                     <h4>@{this.colaborador?.colemail || ' '}&nbsp</h4>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>Data de Nascimento</h5>
                     <h4>@{moment(this.colaborador?.colnascimento).format("DD/MM/YYYY") || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Município de Nascimento</h5>
                     <h4>@{this.municipionascimento?.munnome || ' '}&nbsp</h4>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>Pai</h5>
                     <h4>@{this.colaborador?.colnomepai || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Mãe</h5>
                     <h4>@{this.colaborador?.colnomemae || ' '}&nbsp</h4>
                  </div>
                   <div class="cellElement">
                     <h5>Nome do Cônjuge</h5>
                     <h4>@{this.colaborador?.colnomeconjuge || ' '}&nbsp</h4>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>Cor</h5>
                     <h4>@{this.colaborador?.colcoretiniadesc || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Estado Civil</h5>
                     <h4>@{this.colaborador?.colestadocivildesc || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Grau de Instrução</h5>
                     <h4>@{this.colaborador?.colescolaridadedesc || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Possui deficiência?</h5>
                     <h4>@{this.colaborador?.coloutradeficiencia || this.colaborador?.coldeficienciadesc || ' '}&nbsp</h4>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>Tipo da Conta</h5>
                     <h4>@{this.contabancaria?.colcbtipodesc || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Banco</h5>
                     <h4>@{this.contabancaria?.colcbbanco || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Agência</h5>
                     <h4>@{this.contabancaria?.colcbagencia || ' '}&nbsp</h4>
                  </div>
                  <div class="cellElement">
                     <h5>Conta Nº</h5>
                     <h4>@{this.contabancaria?.colcbconta || ' '}&nbsp</h4>
                  </div>
               </div>
               <div class="rowElement">
                  <div class="cellElement">
                     <h5>Observação</h5>
                     <h4 style="text-wrap: wrap">@{this.colaborador?.colobservacao || ' '}&nbsp</h4>
                  </div>
               </div>
            </div>
         </th>
      </tr>
   </thead>
   <tbody>
      <tr style="border-width: 0px">
         <td style="height: 10px; border-width: 0px"></td>
      </tr>        
      <tr>
         <td style="border-width: 0px; border-top-width: 0; border-color: black; border-style: solid; overflow: hidden; text-align: center;">
            <div style="font-size: 0.85em; margin-bottom: 10px">
               <p>
                  <span>Quantidade de Dependentes: @{this.colaborador?.coldependentes || '0'}</span>                   
               </p>
            </div>
         </td>
      </tr>
      <tr style="border-width: 0px">
         <td style="height: 2px; border-width: 0px"></td>
      </tr> 
      <tr>
         <td style="border-width: 0px; border-top-width: 0; border-color: black; border-style: solid; overflow: hidden">
            <div style="text-align: justify; font-size: 0.75em">
               <p>
                  <span><span style="text-decoration: underline; font-weight: bold">ATENÇÃO:</span> Para fazer jus ao benefício do salário família e parcela a deduzir no IRF deverão ser apresentados os seguintes documentos: Certidão de Nascimento, CPF, Declaração escolar e Carteira de Vacinação atualizada de todos os dependentes</span>                   
               </p>
            </div>
         </td>
      </tr>  
      <tr style="border-width: 0px">
         <td style="height: 8px; border-width: 0px"></td>
      </tr>            
      <tr class="rowElementTr">      
         <td style="border-width: 1px; border-color: black; border-style: solid; overflow: hidden">
         <div style="flex: 1; justify-content: space-between; padding: 1px; font-size: 12px">
           <p>
<span>Possui filiação ou é sindicalizado? ( @{((this.colaborador?.colsindicalizado || 0) == 1) ? 'X' : '&nbsp&nbsp'} ) Sim    ( @{((this.colaborador?.colsindicalizado || 0) == 0) ? 'X' : '&nbsp&nbsp'} ) Não </span>         
			</p>
            <p>
<span>Deseja que haja desconto de um dia de remuneração de Contribuição Sindical Anual em favor do Sindicato da Classe? ( @{((this.colaborador?.colcontribuicaosindical || 0) == 1) ? 'X' : '&nbsp&nbsp'} ) Sim    ( @{((this.colaborador?.colcontribuicaosindical || 0) == 0) ? 'X' : '&nbsp&nbsp'} ) Não</span>         
			</p>
          </div>
         </td>
      </tr>   
      <tr style="border-width: 0px">
         <td style="height: 8px; border-width: 0px"></td>
      </tr>      
      <tr>
         <td style="border-width: 0px; border-top-width: 0; border-color: black; border-style: solid; overflow: hidden">
            <div style="text-align: justify; font-size: 0.75em; margin-top: 10px; margin-bottom: 10px">
               <p style="margin: 1px;">
                  <span style="font-weight: bold">O empregado toma ciência desde já, que seus dados ora fornecidos serão tratados exclusivamente para manutenção do Contrato de Trabalho, permanecendo nas dependências da empresa até o limite prescricional das legislações trabalhista e previdenciária, em cumprimento à Lei 13.709/2019 artigos 7º e 11, podendo o Empregado a quaisquer momentos solicitá-los.</span>                               
               </p>               
               <p style="margin: 1px; margin-top: 10px">
                  <span>Ciente, confirmo os dados informados acima e responsabilizo-me pelas informações prestadas, conforme assinatura abaixo, comprometendo me a comunicar a empresa posssível desistência da vaga, ficando ciente que o não comparecimento na admissão ou no dia posterior implica em desistência, autorizando desde já a exclusão do meu cadastro junto ao E-social e demais sistemas de registro da empresa e governamental:</span>   
               </p>
            </div>
         </td>
      </tr>      
   </tbody>
   <tfoot>
      <tr style="border-width: 0px">
         <td style="height: 8px"></td>
         <td style="height: 8px"></td>
      </tr>
      <tr class="rowElementTr">      
         <td style="border-width: 1px; border-color: black; border-style: solid; overflow: hidden; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
         <div style="display: flex; flex-direction: row">
         <div style="flex: 1; justify-content: space-between">
<span style="font-size: 0.8em">Ciente, confirmo os dados informados acima e responsabilizo-me pelas informações prestadas, conforme assinatura abaixo:</span>         
            <div class="itemline" style="justify-content: space-between;">
               <div style="flex: 1; display: flex; flex-direction: column;"> 
                  <span class="signfield">@{this.colaborador?.colnome || 'Assinatura'}</span>
               </div>
            </div>
          </div>
          <div style="width: 8px">
          </div>
          <div style="display: flex; flex-direction: column; flex: 1; justify-content: space-between">
            <span style="font-size: 0.8em">Nome e assinatura do responsável pelo preenchimento:</span>     
            <div class="itemline" style="justify-content: space-between">
               <div style="flex: 1; display: flex; flex-direction: column;"> 
                  <span class="signfield">@{this.solicitante?.usunome || 'Assinatura'}</span>
               </div>
            </div>
          </div>
          </div>
         </td>
      </tr>
      <tr style="border-width: 0px">
         <td style="height: 8px"></td>
      </tr>      
      <tr>
         <td>
            <div class="itemline" style="justify-content: space-between; font-size: 0.8em">
               <span style="flex: 1">@{moment(new Date()).format("DD/MM/YYYY HH:mm:ss")}</span>
               <div style="display: flex; flex-direction: column;">
                  <img src="https://i.ibb.co/gjK1Zvy/black-logo-white-background.png" style="height: 18px; width: auto; display: block; object-fit: contain;" aling="center" />
               </div>
               <span style="text-align: right; flex: 1">Usuário: @{this.usuario?.usunome || ''}</span>
            </div>
         </td>
      </tr>
   </tfoot>
</table>
<style>
body {
    font-family: Arial, sans-serif;
    margin-left: 20px;
    margin-right: 15px;
    margin-top: 15px;
}

   @media print {
   tr {
   page-break-inside: avoid;
   break-inside: avoid;
   page-break-after:auto;
   break-after:auto;
   }
   tfoot {
   display: table-footer-group;
   }
   thead {
   display:  table-header-group;
   }            
   }        
   thead tr th, tbody tr td {
   border-width: 1px;
   border-color: black;
   border-style: solid;
   padding: 0px;   
   }
   thead .paddingContent th {
   
   }
   .paddingContent th, .paddingContent td{
   padding-left: 8px;
   padding-right: 8px;   
   }
   .rowElementTr td {
   align-content: center;
   text-align: center;
   margin: auto
   }
   @page {
   size: A4;
   margin-left: 0;
   margin-right: 0;            
   }
   table {
   width: 100%;
   padding-bottom: 10px;
   }
   tbody {
   vertical-align: baseline;
   }
   th {
   text-align: left;           
   }
   tr {
   margin-top: 0px;
   }
   td, th {
   padding-top: 3px;
   padding-bottom: 3px;
   padding-left: 3px;
   padding-right: 3px;
   }
   body {
   font-family: calibri, arial;
   print-color-adjust: exact;
   }
   .title {
   text-align: center;
   }
   .subtitle {
   text-align: center;
   margin: 8px;
   }
   .empdata {
   text-align: center;
   margin: 0px;        
   }
   .date {
   text-align: center;
   margin: 5px;        
   }
   .pesli {
   padding: 10px;
   }
   .pesquantidadevalue {
   position: absolute;
   right: 20px;
   border: 1px #000000;
   }
   .totalgroupli {
   padding: 10px;
   }
   .totalgrouplabel {
   text-transform: uppercase;
   color: #ffffff;
   font-weight: bold;
   }
   .totalgroupvalue {
   position: absolute;
   right: 20px;
   color: #ffffff;
   font-weight: bold;
   }
   .itemline {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   }
   .floatval {
   text-align: right;
   white-space: nowrap;
   }
   .signfield {
   margin-top: 50px;
   margin-bottom: 5px;
   margin-left: 50px;
   margin-right: 50px;
   flex: 1; 
   text-align: center;
   border-top: 1px solid;
   z-index: 1;
   }
   .rowElement{
   display: flex;
   flex-direction: row;   
   }
   .rowElementTr {
   border-width: 1px;
   border-color: black;
   border-style: solid;
   }
   .cellElement {
   flex: 1;
   border-width: 1px 1px 0px 0;
   border-color: black;
   border-style: solid;
   }
.cellElementLn {
   flex: 1;
   border-width: 0px 1px 0px 0;
   border-color: black;
   border-style: solid;
   }   
   .cellElement h4,.cellElementLn h4,.cellElement h2,.cellElementLn h2 {
   margin: 4px;
   text-wrap: nowrap;
   margin-left: 8px;
   }
   .cellElement h5,.cellElementLn h5{
   margin: 4px;
   margin-bottom: 0;
   margin-left: 8px;
   }
   cellElementLn h4 {
   margin-right: 8px;
   }
   .cellElementLn h5{
   margin-right: 8px;
   }   
   tr {
   outline: 0px solid;
   }
   p {
   margin: 4px;
   }
</style>
`